if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"host-template","remotes":[{"alias":"appShell","name":"appShell","entry":"https://cdn.inflearn.com/monolith/shared-components/app-shell/assets/appShell.remoteEntry.js","shareScope":"default"}]},
		chunkMatcher: function(chunkId) {return !/^(242|3796|5380|6799|6811)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}